import PropTypes from "prop-types"
import { ContextualFeaturePermissionFragment } from "@pathwright/graphql-client/src/generated"
import { featurePropType } from "../propTypes"
import FeatureBlock from "./FeatureBlock"

const FeatureBlockItem = ({
  feature,
  to
}: {
  feature: ContextualFeaturePermissionFragment
  to?: string
}) => (
  <FeatureBlock
    featureKey={feature.feature_key}
    featurePermission={feature.permission_in_context}
    to={to}
  />
)

FeatureBlockItem.displayName = "FeatureBlockItem"

FeatureBlockItem.propTypes = {
  feature: PropTypes.shape(featurePropType).isRequired
}

export default FeatureBlockItem
